import { render } from "./StakeholderCard.vue?vue&type=template&id=4a97deb4&scoped=true"
import script from "./StakeholderCard.vue?vue&type=script&lang=js"
export * from "./StakeholderCard.vue?vue&type=script&lang=js"

import "./StakeholderCard.vue?vue&type=style&index=0&id=4a97deb4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a97deb4"]])

export default __exports__